import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { BaseReportComponent } from '../reports/base-report.component';

export enum OrderStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
}

@Component({
  selector: 'tasks-report',
  templateUrl: './tasks-report.component.html',
})
export class TasksReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public tags: any[] = [];
  public groupTags: any[] = [];
  public costCodes: any[] = [];
  public groupCostCodes: any[] = [];
  public customers: any[] = [];
  public suppliers: any[] = [];
  public regions: any[] = [];
  public depots: any[] = [];
  public orderStatuses: any[] = [];
  public taskTypes: any[] = [];
  public statusClosed = OrderStatus.Closed;

  constructor(reportService: ReportService<any, any>, private userService: UserService) {
    super(reportService, false);
    reportService.url = '/api/report/task';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
          this.callbackLoadFilterParam();
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.tags = [];
    this.groupTags = [];
    this.costCodes = [];
    this.groupCostCodes = [];
    this.regions = [];
    this.depots = [];
    this.orderStatuses = [];
    this.taskTypes = [];

    if (this.filterParam) {
      this.tags.push({ label: 'Please Select', value: null });
      if (this.filterParam.tags) {
        if (this.organisationTypeId != 1) {
          this.filterParam.tags
            .sort((x) => x.id)
            .forEach((x) => {
              this.tags.push({ label: x.description, value: x.id });
            });
        } else {
          var groupTags = [];
          var orgKeys = [];
          this.filterParam.tags.forEach((x) => {
            if (!groupTags[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupTags[x.organisationName] = { organisationName: x.organisationName, items: [] };
            }

            groupTags[x.organisationName].items.push(x);
          });

          groupTags.sort((x) => x.organisationName);
          this.groupTags.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupTag = groupTags[orgKeys[i]];

            groupTag.items.forEach((item) => {
              this.groupTags.push({
                label: item.description,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.costCodes.push({ label: 'Please Select', value: null });
      if (this.filterParam.costcodes) {
        if (this.organisationTypeId != 1) {
          this.filterParam.costcodes
            .sort((x) => x.id)
            .forEach((x) => {
              this.costCodes.push({ label: x.name, value: x.id });
            });
        } else {
          var groupCostCodesTmp = [];
          var orgKeys = [];
          this.filterParam.costcodes.forEach((x) => {
            if (!groupCostCodesTmp[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupCostCodesTmp[x.organisationName] = {
                organisationName: x.organisationName,
                items: [],
              };
            }

            groupCostCodesTmp[x.organisationName].items.push(x);
          });

          groupCostCodesTmp.sort((x) => x.organisationName);

          this.groupCostCodes.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupCostCodeIns = groupCostCodesTmp[orgKeys[i]];

            groupCostCodeIns.items.forEach((item) => {
              this.groupCostCodes.push({
                label: item.name,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.customers.push({ label: 'Please Select', value: null });
      if (this.filterParam.customers) {
        this.filterParam.customers.forEach((x) => {
          this.customers.push({ label: x.label, value: x.value });
        });
      }

      this.suppliers.push({ label: 'Please Select', value: null });
      if (this.filterParam.suppliers) {
        this.filterParam.suppliers.forEach((x) => {
          this.suppliers.push({ label: x.label, value: x.value });
        });
      }

      this.orderStatuses.push({ label: 'Please Select', value: null });
      if (this.filterParam.statuses) {
        this.filterParam.statuses
          .sort((x) => x.id)
          .forEach((x) => {
            this.orderStatuses.push({ label: x.name, value: x.id });
          });
      }

      this.taskTypes.push({ label: 'Please Select', value: null });
      if (this.filterParam.types) {
        this.filterParam.types
          .sort((x) => x.id)
          .forEach((x) => {
            this.taskTypes.push({ label: x.name, value: x.id });
          });
      }
    }
  }

  changeSort(event) {
    var event2 = event;
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        customer: {},
        supplier: {},
        pickUpDateFrom: {},
        pickUpDateTo: {},
        completedDateFrom: {},
        completedDateTo: {},
        status: {},
        type: {},
      },
    };
  }
}
